export const LOGIN_ERROR_CODE = {
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  RECOVER_PASSWORD: 'RECOVER_PASSWORD',
} as const;

export type LoginErrorCode = (typeof LOGIN_ERROR_CODE)[keyof typeof LOGIN_ERROR_CODE];

export class LoginAuthError extends Error {
  readonly code: LoginErrorCode;

  constructor(code: LoginErrorCode) {
    super(code);
    this.name = 'LoginAuthError';
    this.code = code;
  }
}

export const isLoginAuthError = (error: unknown): error is LoginAuthError =>
  error instanceof LoginAuthError;
